// extracted by mini-css-extract-plugin
export default {"card":"p_X7D","selected":"Y3o_e","disabled":"mvXYA","price":"Ad1cr","container":"TX1wH","wrapperImage":"sz0GH","imageWrapper":"vtPc6","image":"xUktK","content":"gzkBQ"};